import { z } from 'zod';

export const followUpSchema = z
  .object({
    id: z.string(),
    caption: z.string(),
    text: z.string(),
    is_done: z.boolean(),
    is_deleted: z.boolean(),
    created_at: z.iso.datetime({ offset: true }),
    updated_at: z.iso.datetime({ offset: true }),
    user_id: z.number().int(),
  })
  .transform((raw) => ({
    id: raw.id,
    caption: raw.caption,
    text: raw.text,
    isDone: raw.is_done,
    isDeleted: raw.is_deleted,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
    userId: raw.user_id,
  }));

export type FollowUpEntityApi = z.input<typeof followUpSchema>;
export type FollowUpEntity = z.infer<typeof followUpSchema>;
